import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment.active';

export const apiKeyInterceptor: HttpInterceptorFn = (req, next) => {
  const token = localStorage.getItem('token'); // Retrieve token from localStorage

  const headers: { [key: string]: string } = {
    'x-api-key': environment.ApiKey, // Add API key
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`; // Add Bearer token if it exists
  }

  const modifiedReq = req.clone({ setHeaders: headers });

  return next(modifiedReq);
};
